import React from 'react';
import {connect} from 'react-redux';
import mapDispatch from '~/misc/mapDispatch';
import cs from 'classnames';
import Tabs from '../../tabs/tabs';
import AnonymousBanner from '~/components/search/AnonymousBanner';
import Results from '~/components/search/results/results';
import {updateMyloads, saveBroker, noSaveBroker, hideBroker} from '~/modules/myLoads/actions';
import Spinner from '~/components/common/Spinner';
import {track} from '~/misc/metrics';

import sharedCSS from '~/components/shared.css';
import css from './index.css';
import { searchResultsToggle } from '~/modules/loads/actions';
import { selectTab } from '~/modules/tabs/actions';
import {getQuery} from '~/misc/getQuery';
let key;
class MyLoads extends React.Component {
  constructor(props) {
    super(props);
    this.titleClcik = this.titleClcik.bind(this);
    this.closeToggle = ''
  }
  componentWillMount() {
    track('my loads', {'My loads – homepage': 1});
    key = this.props.isLoggedIn;
    if (this.props.isLoggedIn) {this.props.updateMyloads();}
  }
  componentWillReceiveProps(nexProps) {
    const {turnOn} = this.props;
    if (nexProps.isLoggedIn !== this.props.isLoggedIn && nexProps.isLoggedIn) {this.props.updateMyloads();}
    if(this.props.bookingDeleted.length !== nexProps.bookingDeleted.length){
      const list = this.props.booking.results.shipments.filter(item => nexProps.bookingDeleted.indexOf(item.id) < 0)
      // this.renderTable(list, "booking"); // TODO:单独删除myLoads中的booking的loads,先刷新
      this.props.updateMyloads();
    }

    //Open Currect Load by Query
    const target = getQuery(window.location.href).id ? getQuery(window.location.href).id : '';
    if(target.length !==0 && nexProps.tabs && ['bid', 'booking'].includes(nexProps.tabs) && nexProps[nexProps.tabs==='bid' ? 'bids' : nexProps.tabs].status==='ok'  ) {
      const id = Number(target.split('-').pop());
      const shipment = nexProps[nexProps.tabs==='bid' ? 'bids' : nexProps.tabs].results.shipments.find(el=>el.id === id);
      if(shipment){
        this.closeToggle = shipment.identity
        history.replaceState({}, '', '/my-loads');
        turnOn(shipment.identity)
        setTimeout(()=> document.querySelector(`a[data-id="${id}"]`).scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"}), 500)
      }
    } 
  }
  componentDidMount() {
    const { selectTab } = this.props;
    const target = getQuery(window.location.href).id;
    if(target){
      const tab = target.split('-').shift();
      return selectTab({
        id: 'loads',
        tab: tab
      })
    }
  }
  componentWillUnmount() {
    const {turnOn} = this.props;
    if(this.closeToggle) turnOn(this.closeToggle);
  }
  render() {
    return (
      <div className={cs(sharedCSS.wideStretchable, sharedCSS.unpadded, css.wrap)}>
        <Tabs
          id='loads'
          tabs={[
            {id: 'saved', title: 'Saved', dataqa: 'saved'},
            {id: 'hide', title: 'Hidden', dataqa: 'hide'},
            {id: 'viewed', title: 'Viewed', dataqa: 'viewed'},
            {id: 'bid', title: 'My Offers', dataqa: 'bid'},
            {id: 'booking', title: 'Booking', dataqa: 'booking'},
          ]}
          content={{
            saved: this.renderTable(this.props.saved, 'saved'),
            hide: this.renderTable(this.props.hide, 'hide'),
            viewed: this.renderTable(this.props.viewed, 'viewed'),
            bid: this.renderTable(this.props.bids, 'bid'),
            booking: this.renderTable(this.props.booking, 'booking'),
          }}
          csContents={css.contentWrapper}
          clickFun={this.titleClcik}
        />
      </div>
    );
  }
  renderTable(list, type) {
    if (this.props.userInfo.loading || list.status === 'loading' || this.props.loading) {
      return (
        <div className={cs(css.loadingWrapper)}>
          <Spinner/>
        </div>
      );
    } else if (!this.props.isLoggedIn) {
      return <AnonymousBanner />;
    } else if (list.results && list.results.hasItems) {
      return (
        <Results
          query={list.query}
          hasItems={list.hasItems}
          total={list.total}
          results={list.results}
          sorting={false}
          identity={list.identity}
          collectionTheCompany={this.props.saveBroker}
          noCollectionCompany={this.props.noSaveBroker}
          hideBroker={this.props.hideBroker}
          saveClick={true}
          hideClick={true}
          myloadsType={type}
        />
      );
    }
    return type === 'saved' ? this.notFound('saved') : type === 'hide' ? this.notFound('hidden') :type === 'booking' ? this.notFound("booking") : this.notFound('viewed');
  }
  notFound(type) {
    if (type === 'saved') {
      return (
        <div className={cs(css.notFoundWrapper)}>
          <img src='/assets/saved-empty-state.png' alt=''/>
          <p>No saved loads</p>
          <p>Click 'Save' on the Load page to save the load</p>
        </div>
      );
    } else if (type === 'hidden') {
      return (
        <div className={cs(css.notFoundWrapper)}>
          <img src='/assets/hidden-empty-state.png' alt=''/>
          <p>No hidden loads</p>
        </div>
      );
    }
    return (
      <div className={cs(css.notFoundWrapper)}>
        <img src='/assets/view-empty-state.png' alt=''/>
        <p>No viewed history</p>
      </div>
    );
  }
  titleClcik(title) {
    // 埋点
    switch(title) {
      case 'saved':
        track('my loads', {'Saved': 1});
        break;
      case 'hide':
        track('my loads', {'Hidden': 1});
        break;
      case 'viewed':
        track('my loads', {'Viewed': 1});
        break;
      case 'booking':
          track('my loads', {'booking': 1});
          break;
    }
  }
}

export default connect(({
  user: {isLoggedIn, loading},
  myLoads: {saved, hide, viewed, bid, booking, bookingDeleted},
  account: {userInfo},
  tabs,
}) => ({
  isLoggedIn,
  loading,
  saved,
  hide,
  viewed,
  bids: bid,
  booking,
  userInfo,
  bookingDeleted,
  tabs: tabs.loads
}), mapDispatch({
  updateMyloads: (props, type) => updateMyloads(type),
  saveBroker: (props, data) => saveBroker(data),
  noSaveBroker: (props, data) => noSaveBroker(data),
  hideBroker: (props, data) => hideBroker(data),
  turnOn: (props, id) => searchResultsToggle(id, false),
  selectTab: (props, {id, tab}) => selectTab(id, tab)
}))(MyLoads);



// WEBPACK FOOTER //
// ./src/components/pages/MyLoads/index.js